import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './estilos.css';

/**
 * El service worker es lo que deja llegar los avisos con el portal cerrado.
 *
 * Se registra siempre que el navegador pueda, no solo cuando el cliente los activa: el permiso
 * se pide despues, con un clic suyo (ver ActivarAvisos). Si falla no se dice nada — el portal
 * funciona igual, sin avisos.
 */
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
